// extracted by mini-css-extract-plugin
module.exports = {"selected":"employeePhotoStyles_selected__1Rz4r"};